(() => {
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  const normalizeHandle = (v) => {
    return (v || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  function initBurgerMenu(root) {
    if (root.__lab51bm) return; // ✅ evita doble init

    const btnClose = qs(root, "[data-lab51-burger-menu-close]");
    const overlay = qs(root, "[data-lab51-burger-menu-overlay]");
    const drawer = qs(root, "[data-lab51-burger-menu-drawer]");
    const topnav = qs(root, "[data-lab51-burger-menu-topnav]");
    const tabs = qsa(root, "[data-lab51-burger-menu-tab]");
    const panels = qsa(root, "[data-lab51-burger-menu-panel]");

    if (!drawer || !topnav) return;

    const state = {
      open: false,
      activeHandle: null,
      activePanel: null,
      lastOpener: null
    };

    const sliderResets = new WeakMap();

    const getPanelByHandle = (handle) => {
      const h = normalizeHandle(handle);
      if (!h) return null;
      return panels.find((p) => normalizeHandle(p.dataset.handle) === h) || null;
    };

    const setActive = (handle) => {
      const h = normalizeHandle(handle);
      const panel = getPanelByHandle(h);
      if (!panel) return false;

      if (state.activePanel && state.activePanel !== panel) {
        const resetPrev = sliderResets.get(state.activePanel);
        if (typeof resetPrev === "function") resetPrev();
      }

      state.activeHandle = h;
      state.activePanel = panel;

      tabs.forEach((t) => {
        const th = normalizeHandle(t.dataset.handle);
        const isActive = th === h;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-current", isActive ? "page" : "false");
      });

      panels.forEach((p) => {
        const ph = normalizeHandle(p.dataset.handle);
        p.classList.toggle("is-active", ph === h);
      });

      root.classList.remove("is-topnav-hidden");
      return true;
    };

    const open = (openerEl = null) => {
      if (state.open) return;
      state.open = true;
      state.lastOpener = openerEl || null;

      root.classList.add("is-open");
      drawer.classList.add("is-open");
      overlay && overlay.classList.add("is-open");
      document.documentElement.classList.add("lab51-bm-lock");

      if (!state.activeHandle) {
        for (const t of tabs) {
          const h = normalizeHandle(t.dataset.handle);
          if (getPanelByHandle(h)) {
            setActive(h);
            break;
          }
        }
      }

      drawer.focus({ preventScroll: true });
    };

    const close = () => {
      if (!state.open) return;
      state.open = false;

      root.classList.remove("is-open");
      drawer.classList.remove("is-open");
      overlay && overlay.classList.remove("is-open");
      document.documentElement.classList.remove("lab51-bm-lock");
      root.classList.remove("is-topnav-hidden");

      if (state.lastOpener && typeof state.lastOpener.focus === "function") {
        try { state.lastOpener.focus({ preventScroll: true }); } catch (_) {}
      }
      state.lastOpener = null;
    };

    // close
    btnClose && btnClose.addEventListener("click", close);
    overlay && overlay.addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (!state.open) return;
      if (e.key === "Escape") close();
    });

    // tabs
    topnav.addEventListener("click", (e) => {
      const a = e.target.closest("[data-lab51-burger-menu-tab]");
      if (!a) return;

      const handle = normalizeHandle(a.dataset.handle);
      const panel = getPanelByHandle(handle);

      if (panel) {
        e.preventDefault();
        setActive(handle);
        return;
      }

      const url = a.getAttribute("href") || a.dataset.url;
      close();
      if (url) window.location.href = url;
    });

    // sliderule
    panels.forEach((panel) => {
      const groupBtns = qsa(panel, "[data-lab51-bm-sliderule-group]");
      const rightWrap = qs(panel, "[data-lab51-bm-sliderule-right]");
      const backBtn = qs(panel, "[data-lab51-bm-sliderule-back]");
      const sliderPanels = qsa(panel, "[data-lab51-bm-sliderule-panel]");
      const hideTopnavOn = panel.dataset.hideTopnavOnSliderule === "true";

      if (!groupBtns.length || !rightWrap || !sliderPanels.length) {
        sliderResets.set(panel, () => {
          panel.classList.remove("is-sliderule-active");
          root.classList.remove("is-topnav-hidden");
        });
        return;
      }

      const leftWrap = qs(panel, ".lab51-bm__sliderule-left");

      const setSliderIndex = (idx) => {
        const i = String(idx);

        sliderPanels.forEach((sp) => {
          sp.classList.toggle("is-active", sp.dataset.index === i);
        });

        panel.classList.add("is-sliderule-active");
        if (hideTopnavOn) root.classList.add("is-topnav-hidden");

        if (leftWrap) leftWrap.classList.add("is-hidden");
        rightWrap.classList.add("is-active");
      };

      const resetSliderule = () => {
        const hasAnyActive =
          panel.classList.contains("is-sliderule-active") ||
          sliderPanels.some((sp) => sp.classList.contains("is-active"));

        if (!hasAnyActive) return;

        panel.classList.remove("is-sliderule-active");
        sliderPanels.forEach((sp) => sp.classList.remove("is-active"));

        if (hideTopnavOn) root.classList.remove("is-topnav-hidden");

        if (leftWrap) leftWrap.classList.remove("is-hidden");
        rightWrap.classList.remove("is-active");
      };

      sliderResets.set(panel, resetSliderule);

      groupBtns.forEach((btn) => {
        btn.addEventListener("click", () => setSliderIndex(btn.dataset.index));
      });

      backBtn && backBtn.addEventListener("click", resetSliderule);
    });

    // ✅ expone API para que el click global pueda abrir este root
    root.__lab51bm = { open, close };
  }

  function boot() {
    const roots = Array.from(document.querySelectorAll("[data-lab51-burger-menu-root]"));
    roots.forEach(initBurgerMenu);

    // ✅ CLICK GLOBAL: funciona aunque el botón esté fuera del root
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-lab51-burger-menu-open]");
      if (!btn) return;

      e.preventDefault();

      // 1) si está dentro del root
      let root = btn.closest("[data-lab51-burger-menu-root]");

      // 2) si está fuera, usamos target
      if (!root) {
        const targetId = btn.getAttribute("data-lab51-burger-menu-target");
        if (targetId) {
          root = document.querySelector(
            `[data-lab51-burger-menu-root][data-section-id="${CSS.escape(targetId)}"]`
          );
        }
      }

      // 3) fallback
      if (!root) root = roots[0];

      if (root && root.__lab51bm) root.__lab51bm.open(btn);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();